import actions from './actions';
import reducer from './reducer';
import selectors from './selectors';

// This is named for easy editor imports
const ProjectGroupModule = { actions, reducer, selectors };
export default ProjectGroupModule;
